











































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import RekapBulananIgd, {
  RekapBulananIgdResponse,
  keyKasus,
  keyCaraBayar,
  keyTempatPenuh,
  KEY_DARI_RS,
  KEY_DARI_PUSKESMAS,
  KEY_DARI_BP_RB,
  KEY_DARI_DOKTER_BIDAN,
  KEY_DIRUJUK,
  KEY_MATI
} from "@/services/RekapBulananIgd";

interface OpsiItem {
  key: string;
  label: string;
}

@Component({})
export default class LaporanRekapBulananIgdPage extends Vue {
  data: RekapBulananIgdResponse | null = null;
  loading = false;
  saving = false;
  printing = false;

  tahun = moment().year();
  bulan = moment().month() + 1;

  draft: Record<string, number> = {};
  berubah = false;

  readonly KEY_DARI_RS = KEY_DARI_RS;
  readonly KEY_DIRUJUK = KEY_DIRUJUK;
  readonly KEY_MATI = KEY_MATI;

  readonly kasusList: OpsiItem[] = [
    { key: "bedah", label: "Kasus Bedah" },
    { key: "non_bedah", label: "Kasus Non Bedah" },
    { key: "kebidanan", label: "Kasus Kebidanan" }
  ];

  readonly faskesList: OpsiItem[] = [
    { key: KEY_DARI_PUSKESMAS, label: "Puskesmas" },
    { key: KEY_DARI_BP_RB, label: "BP/RB" },
    { key: KEY_DARI_DOKTER_BIDAN, label: "Dokter/Bidan" }
  ];

  readonly bayarList: OpsiItem[] = [
    { key: "umum", label: "Pasien Umum" },
    { key: "askes", label: "Pasien Askes/BPJS" },
    { key: "lain", label: "Pasien Lain-lain" }
  ];

  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 }
  ];

  get tahunOptions(): number[] {
    const kini = moment().year();
    const list: number[] = [];
    for (let t = kini; t >= kini - 5; t--) list.push(t);
    return list;
  }

  keyKasus(seksi: string, kasus: string): string {
    return keyKasus(seksi, kasus);
  }

  keyCaraBayar(bayar: string, tl: string): string {
    return keyCaraBayar(bayar, tl);
  }

  keyTempatPenuh(bayar: string): string {
    return keyTempatPenuh(bayar);
  }

  get jumlahKeAtas(): number {
    return this.kasusList.reduce(
      (t, k) => t + this.nilai(keyKasus("rujukan_ke_atas", k.key)),
      0
    );
  }

  get jumlahDariBawah(): number {
    return this.kasusList.reduce(
      (t, k) => t + this.nilai(keyKasus("rujukan_dari_bawah", k.key)),
      0
    );
  }

  get jumlahDatangSendiri(): number {
    return this.kasusList.reduce(
      (t, k) => t + this.nilai(keyKasus("datang_sendiri", k.key)),
      0
    );
  }

  get jumlahTempatPenuh(): number {
    return this.bayarList.reduce(
      (t, b) => t + this.nilai(keyTempatPenuh(b.key)),
      0
    );
  }

  get totalRalan(): number {
    return this.bayarList.reduce(
      (t, b) => t + this.nilai(keyCaraBayar(b.key, "ralan")),
      0
    );
  }

  get totalRanap(): number {
    return this.bayarList.reduce(
      (t, b) => t + this.nilai(keyCaraBayar(b.key, "ranap")),
      0
    );
  }

  mounted(): void {
    this.muat();
  }

  async muat(): Promise<void> {
    this.loading = true;
    const res = await RekapBulananIgd.get({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => null);
    if (res) this.terapkan(res);
    else this.data = null;
    this.loading = false;
  }

  async simpan(): Promise<void> {
    if (!this.data) return;
    this.saving = true;
    const res = await RekapBulananIgd.save(
      { tahun: this.tahun, bulan: this.bulan },
      { ...this.draft }
    ).catch(() => null);
    if (res) this.terapkan(res);
    this.saving = false;
  }

  async cetak(): Promise<void> {
    this.printing = true;
    await RekapBulananIgd.openPdf({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => undefined);
    this.printing = false;
  }

  private terapkan(res: RekapBulananIgdResponse): void {
    this.data = res;
    this.draft = { ...res.koreksi };
    this.berubah = false;
  }

  nilaiRme(key: string): number {
    if (!this.data) return 0;
    return this.data.rme[key] || 0;
  }

  nilai(key: string): number {
    if (Object.prototype.hasOwnProperty.call(this.draft, key)) {
      return this.draft[key];
    }
    return this.nilaiRme(key);
  }

  tampil(key: string): string {
    const v = this.nilai(key);
    return v > 0 ? String(v) : "";
  }

  dikoreksi(key: string): boolean {
    return (
      Object.prototype.hasOwnProperty.call(this.draft, key) &&
      this.draft[key] !== this.nilaiRme(key)
    );
  }

  tooltip(key: string): string {
    return this.dikoreksi(key)
      ? `Dikoreksi manual — hitungan RME: ${this.nilaiRme(key)}`
      : "Angka dari data RME";
  }

  ubah(key: string, ev: Event): void {
    const el = ev.target as HTMLInputElement;
    const bersih = el.value.replace(/[^0-9]/g, "");
    if (bersih !== el.value) el.value = bersih;

    const angka = bersih === "" ? 0 : parseInt(bersih, 10);

    if (angka === this.nilaiRme(key)) {
      this.$delete(this.draft, key);
    } else {
      this.$set(this.draft, key, angka);
    }

    this.berubah = true;
  }
}
